import { render, staticRenderFns } from "./WidgetConversationFeelings.vue?vue&type=template&id=aeb71680&scoped=true&"
import script from "./WidgetConversationFeelings.vue?vue&type=script&lang=js&"
export * from "./WidgetConversationFeelings.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConversationFeelings.vue?vue&type=style&index=0&id=aeb71680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb71680",
  null
  
)

export default component.exports